import type { RouteRecordRaw } from 'vue-router'

export const highlightTemplatesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/highlight-templates',
    name: 'HIGHLIGHT_TEMPLATES',
    component: () => import('./HighlightTemplatesPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
